<template>
  <el-input v-bind="$attrs" v-on="mergedListeners" :value="localValue">
    <template v-if="$slots.prepend" #prepend>
      <slot name="prepend"></slot>
    </template>
    <template v-if="$slots.append" #append>
      <slot name="append"></slot>
    </template>
    <template v-if="$slots.prefix" #prefix>
      <slot name="prefix"></slot>
    </template>
    <template v-if="$slots.suffix" #suffix>
      <slot name="suffix"></slot>
    </template>
  </el-input>
</template>

<script>
import _ from "lodash";
export default {
  name: "DebounceInput",
  emits: ["input"],
  props: {
    value: [String, Number],
    debounce: {
      type: Number,
      default: 500,
    },
  },
  computed: {
    mergedListeners() {
      return {
        ...this.$listeners,
        input: this.onInput,
      };
    },
  },
  data() {
    return {
      localValue: this.value,
    };
  },
  created() {
    // Use lodash debounce for input event
    this.emitInput = _.debounce((val) => {
      this.$emit("input", val);
    }, this.debounce);
  },
  methods: {
    onInput(val) {
      this.localValue = val;
      this.emitInput(val);
    },
  },
};
</script>
